import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BillingManagementService } from '../../../service/billing-management.service';
import { ConfigurationManagementService } from '../../../service/configuration-management.service';
import { LanguageManagementService } from '../../../service/language-management.service';
import { GeneralConfigType, InteractionType, KeyValueSet, LocalService, MessageSettingsWrapper, NotificationType, PageKey, RelationShipRole, TriggeredEvent, Wrappers5 } from '../../../service/local.service';
import { LocalDatePipe } from '../../pipes/local-date.pipe';
import { AddMessageCreditsComponent } from '../../popups/add-message-credits/add-message-credits.component';
import { SmsSettingsComponent } from '../../popups/sms-settings/sms-settings.component';

@Component({
  selector: 'app-sms-report',
  templateUrl: './sms-report.component.html',
  styleUrls: ['./sms-report.component.scss']
})
export class SmsReportComponent implements OnInit {
  lstSectionConfigKeys: string[] = ["sms_settings"]; relationShipType: InteractionType = InteractionType.Business;
  businessId = ''; interactionType: InteractionType = 0; availableCredits = 0; selectedDate: string; maxBodyHeight = 0;
  notificationType: NotificationType = NotificationType.WhatsApp; wrapper: Wrappers5; selectedNotificationType = ''; notificationTypes: KeyValueSet[];
  RelationShipRole = RelationShipRole;
  source: MessageSettingsWrapper; isShowActive = true; isActive: boolean = false;

  constructor(public localService: LocalService, private cdr: ChangeDetectorRef, private languageManagementService: LanguageManagementService, private route: ActivatedRoute, public billingManagementService: BillingManagementService, private modalService: NgbModal, private configurationManagementService: ConfigurationManagementService) { }

  ngOnInit(): void {
    this.selectedNotificationType = this.notificationType.toString();
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.configurationManagementService.getConfigurationsToDisplay(GeneralConfigType.NotificationType).subscribe(result => {
      this.notificationTypes = result;
    });
    this.route.params.subscribe(routeParams => {
      this.interactionType = routeParams.interactionType;
      this.businessId = routeParams.businessId;
      if (this.interactionType == InteractionType.ServiceProvider) {
        this.relationShipType = InteractionType.ServiceProvider;
        this.configurationManagementService.ensurePageActions(PageKey.SmsReportServiceProvider);
      } else if (this.interactionType == InteractionType.Business) {
        this.relationShipType = InteractionType.Business;
        this.configurationManagementService.ensurePageActions(PageKey.SmsReportBusiness, this.businessId);
      }
      if (this.interactionType == InteractionType.Business && (this.businessId == '' || this.businessId == '0')) {
        this.localService.redirectToSeller();
      } else if (this.interactionType == InteractionType.ServiceProvider && (this.businessId == '' || this.businessId == '0')) {
        this.localService.onDirectToServiceProviderCreation();
      } else {
        this.localService.saveUrl();
        this.localService.setBasicParams(routeParams.ctryCode, routeParams.userId, routeParams.interactionType, routeParams.businessId);
        this.onInitiate();
      }
    });
  }

  onInitiate() {
    this.onLoadSmsSettings();
    this.onLoad();
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetCustomBodyHeight();
    this.cdr.detectChanges();
  }

  onLoad() {
    this.notificationType = parseInt(this.selectedNotificationType);
    this.onLoadMessageCredits();
    this.billingManagementService.getMessageLogs(this.businessId, this.notificationType, this.relationShipType, this.wrapper ? this.wrapper.paging : null).subscribe(result => {
      this.wrapper = result;
      const localDatePipe = new LocalDatePipe();
      this.selectedDate = localDatePipe.getFromString(this.wrapper.paging.dateFromS);
    });
  }

  onAction(index) {
    switch (index) {
      case 1: {
        const modalRef = this.modalService.open(SmsSettingsComponent, { size: 'lg' });
        modalRef.componentInstance.businessId = this.businessId;
        modalRef.componentInstance.relationShipType = this.relationShipType;
        modalRef.componentInstance.notificationType = this.notificationType;
      } break;
      case 2: {
        const modalRef = this.modalService.open(AddMessageCreditsComponent);
        modalRef.componentInstance.businessId = this.businessId;
        modalRef.componentInstance.relationShipType = this.relationShipType;
        modalRef.componentInstance.notificationType = this.notificationType;
        modalRef.result.then((result) => {
          if (result.event == TriggeredEvent.Ok) {
            this.onLoadMessageCredits();
          }
        });
      } break;
    }
  }

  onLoadSmsSettings() {
    this.billingManagementService.getMessageSettings(this.businessId, this.notificationType, this.relationShipType, false).subscribe(result => {
      this.source = result;
      this.isActive = this.source.content.v4 == '1';
      this.source.content.value = this.source.content.v5 && this.source.content.v5 != '' ? parseInt(this.source.content.v5) : null;
    });
  }

  onLoadMessageCredits() {
    this.billingManagementService.getMessageCredit(this.businessId, this.notificationType, this.relationShipType).subscribe(result => {
      this.availableCredits = parseInt(result.v4);
    });
  }

  onDateSelected() {
    this.wrapper.paging.currentPage = 1;
    this.onLoad();
  }

  onSave() {
    this.source.content.v4 = this.isActive ? '1' : '0';
    this.source.content.v5 = this.source.content.value ? this.source.content.value.toString() : '';
    this.source.selectedForCustomer = [];
    this.source.selectedForBusiness = [];
    this.billingManagementService.saveMessageSettings(this.source, []).subscribe(result => {
      this.localService.showInformationByStatus(result.status);
    });
  }
}
